/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
export default function componentStyle(prefix: string, ...classes: Array<string | undefined>): string {
    return classes
        .filter((x): x is string => typeof x === 'string')
        .map((x) => x.replace(/^&/, prefix))
        .join(' ');
}
